import { AgGridReact } from 'ag-grid-react';

import { DEFAULT_GRID_SETTINGS } from '@/constants/common';
import useGridTheme from '@/hooks/useGridTheme';
import { useFetchAssetAlerts } from '@/pages/Assets';

import { ASSET_ALERTS_TABLE_COLUMNS } from './AssetAlertsTable.constants';

const AssetAlertsTable = () => {
  const { data: selectedAssetAlerts } = useFetchAssetAlerts();
  const gridTheme = useGridTheme();

  return (
    <div style={{ height: 500 }}>
      <AgGridReact
        columnDefs={ASSET_ALERTS_TABLE_COLUMNS}
        gridOptions={DEFAULT_GRID_SETTINGS}
        pagination
        paginationPageSize={20}
        rowData={selectedAssetAlerts || []}
        rowHeight={40}
        theme={gridTheme}
      />
    </div>
  );
};

export default AssetAlertsTable;
